/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-common.tooltips',
    'pip-events'
],
function (
    $,
    Mustache,
    pip,
    pipTooltips,
    pipEvents
){

	var initEventListeners = function(tooltip){
		$(document).off('click.instantRebates');
		$(document).on('click.instantRebates', '#instantRebateDetails', function(e){
			e.preventDefault();
			e.stopPropagation();
			tooltip.rebuild();
			tooltip.display();
			pipEvents.instantRebates.instantRebatesLinkClicked.trigger({eventName: 'instant rebate details'});
		})
	};

	var templates = {
			body: '<div class="savings_table">' +
					'<div class="row">' +
						'<span class="left dots">Everyday Low Price</span>' +
						'<span class="right price">{{#formattedPrice}}{{originalPrice}}{{/formattedPrice}}</span>' +
					'</div>' +
					'<div class="row">' +
						'<span class="left dots">{{longDescription}} Instant Rebate*</span>' +
						'<span class="right price">-{{#formattedPrice}}{{dollarOff}}{{/formattedPrice}}</span>' +
					'</div>' +
				'</div>' +
				'<div class="total_savings">' +
					'<span class="savings_color">Save {{#formattedPrice}}{{dollarOff}}{{/formattedPrice}} ({{percentageOff}}%)</span>' +
					'<span>{{#formattedPrice}}{{specialPrice}}{{/formattedPrice}}</span>' +
				'</div>',

			footer: '<div class="tooltip_footer_inner">' +
						'<strong>{{#formattedPrice}}{{dollarOff}}{{/formattedPrice}} Instant Rebate</strong>' +
						'<ul>' +
							'<li>Rebate amount applied instantly and reflected in price displayed</li>' +
							'<li>Rebate availability is based on location</li>' +
							'<li>Cannot be combined with another offer</li>' +
						'</ul>' +
                        '<p class="legal">* Online rebate may be provided by Home Depot</p>' +
					'</div>'
		};

	return {
		init: function init(){

			if(!pip.products.primary.data.itemExtension.instantRebate) return;

			var renderedBody = Mustache.to_html(templates.body, {
				originalPrice: pip.products.primary.data.itemExtension.localStoreSku.pricing.originalPrice,
				dollarOff: pip.products.primary.data.itemExtension.localStoreSku.pricing.dollarOff,
				percentageOff: pip.products.primary.data.itemExtension.localStoreSku.pricing.percentageOff,
				specialPrice: pip.products.primary.data.itemExtension.localStoreSku.pricing.specialPrice,
				longDescription: pip.products.primary.data.itemExtension.localStoreSku.storePromotion.longDescription,
				formattedPrice: function formattedPrice() {
					return function(num, render) {
						return '$' + parseFloat(render(num)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					};
				}
			});

			var renderedFooter = Mustache.to_html(templates.footer, {
				dollarOff: pip.products.primary.data.itemExtension.localStoreSku.pricing.dollarOff,
				formattedPrice: function formattedPrice() {
					return function(num, render) {
						return '$' + parseFloat(render(num)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					};
				}
			});

			var tooltip = pipTooltips.create({callToActionSelector: '#instantRebateDetails'});

			initEventListeners(tooltip);

			tooltip.title = 'Price Details';
			tooltip.templates = {
				id: 'instantRebatesTooltip',
				body: renderedBody ,
				footer: renderedFooter
			};
		}
	}
});

}.call(window));